/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "ERC1967InvalidAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "ERC1967InvalidBeacon",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
];
const _bytecode = "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220dc2a45bcc06ff1279baa5c823f5216475c97aacdc19aadbda8ffb91ffd8b611164736f6c63430008180033";
const isSuperArgs = (xs) => xs.length > 1;
export class ERC1967Utils__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
ERC1967Utils__factory.bytecode = _bytecode;
ERC1967Utils__factory.abi = _abi;
//# sourceMappingURL=ERC1967Utils__factory.js.map